import { render, staticRenderFns } from "./MenuAplicacoes.vue?vue&type=template&id=215799a8"
import script from "./MenuAplicacoes.vue?vue&type=script&lang=ts"
export * from "./MenuAplicacoes.vue?vue&type=script&lang=ts"
import style0 from "./MenuAplicacoes.vue?vue&type=style&index=0&id=215799a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports